import React, { useState } from "react";
import { portfolio } from "@/data/portfolio";
import useReveal from "@/hooks/useReveal";

const Plate = ({ item, reverse = false, idx }) => {
  const ref = useReveal();
  const [videoFailed, setVideoFailed] = useState(false);
  const currentImage = item.image;

  return (
    <div
      ref={ref}
      data-testid={`study-${idx}`}
      className={`reveal-up grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start ${reverse ? "md:[&>div:first-child]:order-2" : ""}`}
    >
      <div className="md:col-span-7 relative">
        <div className="relative overflow-hidden rounded border group cursor-pointer" style={{ background: "var(--paper-2)", borderColor: "var(--rule)" }}>
          {item.video && !videoFailed ? (
            <video
              src={item.video}
              poster={currentImage}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              onError={() => setVideoFailed(true)}
              className="w-full h-[60vh] md:h-[80vh] object-cover editorial-img transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-103"
              data-testid={`study-${idx}-video`}
            />
          ) : (
            <img
              src={currentImage}
              alt={item.alt}
              className="w-full h-[50vh] sm:h-[60vh] md:h-[80vh] object-cover editorial-img transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-103"
              loading="lazy"
            />
          )}
        </div>
        <div className="flex items-center justify-between mt-3">
          <div className="font-mono text-[0.72rem] uppercase tracking-microcap" style={{ color: "var(--ink-muted)" }}>
            <span style={{ color: "var(--ink)" }}>{item.code}</span>
            <span className="slash" />
            <span>{item.cap}</span>
          </div>
          <div className="font-mono text-[0.72rem] uppercase tracking-microcap" style={{ color: "var(--ink-muted)" }}>
            {item.capRight}
          </div>
        </div>
      </div>
      <div className="md:col-span-5 md:pt-8">
        <div className="flex items-center justify-between mb-6 font-mono text-[0.72rem] uppercase tracking-microcap" style={{ color: "var(--ink-muted)" }}>
          <span>{item.meta1}</span>
          <span>{item.meta2}</span>
        </div>
        <div className="font-mono text-[0.78rem] uppercase tracking-microcap mb-3" style={{ color: "var(--accent)" }}>{item.code}</div>
        <h3 className="font-serif text-3xl md:text-4xl tracking-tightest leading-[1.05]">{item.title}</h3>
        <p className="font-serif text-lg md:text-xl mt-5 leading-relaxed max-w-[40ch]">{item.body}</p>
      </div>
    </div>
  );
};

const Studies = () => {
  const { studies } = portfolio;
  return (
    <section id="studies" data-testid="studies-section" className="px-5 md:px-10 py-14 md:py-28" style={{ background: "var(--paper-2)" }}>
      <div className="mx-auto max-w-[1400px]">
        <div className="flex items-baseline justify-between mb-6 md:mb-10">
          <div className="section-tag">
            <span style={{ color: "var(--ink)" }}>{studies.section}</span>
            <span className="ml-3">{studies.eyebrow}</span>
          </div>
          <div className="section-tag">Plates A.01 — A.02</div>
        </div>
        <h2 className="display text-4xl sm:text-5xl md:text-7xl lg:text-8xl max-w-[18ch] mb-6 md:mb-8">
          Two studies in <span className="display-italic" style={{ color: "var(--accent)" }}>vision and action</span>
        </h2>
        <p className="font-serif text-base sm:text-lg md:text-xl max-w-[60ch] mb-10 md:mb-20" style={{ color: "var(--ink-2)" }}>
          {studies.intro}
        </p>

        <div className="space-y-16 md:space-y-32">
          {studies.items.map((it, i) => (
            <Plate key={it.code} item={it} reverse={i % 2 === 1} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Studies;
